import clsx from 'clsx';
import React from 'react';

import { ProButton } from '@components/Button/variants';
import EmailLeadCapture from '@components/EmailLeadCapture';
import { ORG_CHARTS_PRO_ONLY_MESSAGE } from '@components/pages/OrgCharts/constants';
import useEventTracking from '@hooks/useEventTracking';
import usePaywallCTAs from '@hooks/usePaywallCTAs';
import { FormLocation } from '@utils/enums';

import { OrgChartsPaywallProps } from '../interfaces';

const OrgChartBottomPaywall = ({ currentUser, shouldShowPaywall }: OrgChartsPaywallProps) => {
  const { trackEvent } = useEventTracking();

  const { paywallCTAText, paywallCTAPath, handleCTAClickTracking } = usePaywallCTAs({
    currentUser,
    trackEvent,
  });

  return (
    <aside className="fixed inset-0 z-[90] overflow-hidden" data-testid="paywall-overlay">
      <div className="fixed bottom-0 left-0 right-0 z-[95] flex flex-col">
        <div className="pointer-events-none h-80 w-full bg-[linear-gradient(to_bottom,_rgba(255,255,255,0)_0%,_rgba(255,255,255,0.9)_70%,_rgba(255,255,255,1)_100%)] sm:h-[120px]" />

        <div className="z-[100] w-full bg-white sm:bg-grayscale-charcoal" data-testid="paywall">
          <div
            className={clsx(
              'mx-auto flex w-full max-w-container-lg flex-col items-center justify-center px-40 py-24',
              currentUser ? 'sm:gap-24 md:py-48' : 'sm:gap-32 md:pt-48'
            )}
          >
            <div className="flex flex-col md:max-w-[750px]">
              <h3 className="text-grayscale-black mx-auto my-0 max-w-[425px] text-center font-suisse-neue text-subheadline-sm sm:max-w-none sm:text-headline-md sm:text-white md:text-headline-lg">
                {ORG_CHARTS_PRO_ONLY_MESSAGE}
              </h3>
            </div>
            <div className="mt-8 w-full max-w-full sm:max-w-[430px]">
              {currentUser ? (
                <ProButton
                  as="link"
                  className="mx-auto"
                  href={paywallCTAPath()}
                  onClickCapture={handleCTAClickTracking}
                >
                  {paywallCTAText}
                </ProButton>
              ) : shouldShowPaywall ? (
                <EmailLeadCapture
                  buttonClassName="w-full md:w-auto"
                  buttonText="Subscribe"
                  formLocation={FormLocation.OrgChartsLanding}
                  redirectToOnSuccess="/subscribe"
                  oauthButtonsClassName="mt-16"
                  inputClassName="w-full"
                  signInOptionClass="text-left !text-grayscale-gray sm:!text-grayscale-beige !opacity-100 *:!opacity-100"
                  expandableOathButtonsClassName="!text-grayscale-gray sm:!text-grayscale-beige"
                  includeSignInOption
                  isPro
                  isVertical
                  isVerticalMobile
                  withOauth
                  withOnlyOauthExpandable
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default OrgChartBottomPaywall;
